import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import { useMediaQueries } from '../../usecontext/UseProvider';
import ImageUploadField from '../CommonTextField/ImageUploadField';
import CustomTextField from '../CommonTextField/CustomTextField';
import SuccessModal from '../successModal/SuccessModal';
import { updateAboutGallery } from '../../services/AboutGallery';

const validationSchema = Yup.object({
    title: Yup.string().required('The title field is required.'),
    description: Yup.string().required('The description field is required.'),
    // image: Yup.array()
    //     .min(4, 'You must upload at least 4 images')
    //     .required('The image field is required.'),
});

const AboutGalleryModal = ({ open, setOpen, aboutGalleryData, onUpdateSuccess }) => {
    const { isMediumScreen, setLoading } = useMediaQueries();
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (aboutGalleryData) {
            formik.setValues({
                title: aboutGalleryData.title || '',
                description: aboutGalleryData.description?.join('\n') || '',
                image: null,
            });
        }
    }, [aboutGalleryData]);

    const formik = useFormik({
        initialValues: {
            title: aboutGalleryData?.title || '',
            description: aboutGalleryData?.description?.join('\n') || '',
            image: null,
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);
                setError('');
                const formData = new FormData();
                formData.append('title', values.title);
                formData.append('description', values.description);
                
                if (values.image) {
                    Array.from(values.image).forEach((file) => {
                        formData.append('images', file);
                    });
                }

                const response = await updateAboutGallery(formData, aboutGalleryData?._id);
                
                if (response?.error) {
                    setError(response.error);
                } else {
                    setOpen(false);
                    setSuccessModalOpen(true);
                    onUpdateSuccess(response?.aboutGalleryData);
                }
            } catch (error) {
                setError('Failed to update about gallery. Please try again.');
            } finally {
                setLoading(false);
            }
        },
    });

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-Home-Carosal"
                aria-describedby="modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isMediumScreen ? '90%' : '60%',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 2,
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography id="modal-Home-Carosal" variant="h5" component="h2">
                            Change image & text
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <form onSubmit={formik.handleSubmit}>
                        <Box sx={{ display: { sm: 'flex' }, gap: 3 }}>
                            <Box sx={{ width: { sm: '50%' } }}>
                                <ImageUploadField
                                    sx={{ mt: 2 }}
                                    label="Image"
                                    name="image"
                                    formik={formik}
                                    data={aboutGalleryData}
                                    imageHeight='70px'
                                    imageWidth='70px'
                                    multiple
                                />
                                <CustomTextField
                                    label="Title"
                                    name="title"
                                    formik={formik}
                                    placeholder="Enter Title"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                            </Box>
                            <Box sx={{ width: { sm: '50%' }, mt: 2 }}>
                                <CustomTextField
                                    label="Description"
                                    name="description"
                                    formik={formik}
                                    placeholder="Enter Description"
                                    minRows={4}
                                    multiline={true}
                                />
                            </Box>
                        </Box>

                        {error && (
                            <Typography color="error" variant="caption" sx={{ mt: 2, display: 'block' }}>
                                {error}
                            </Typography>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 4 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    borderRadius: '10px',
                                    borderColor: '#01A0E2',
                                    color: '#000',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    borderRadius: '10px',
                                    backgroundColor: '#01A0E2',
                                    color: '#fff',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                            >
                                Update
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>

            <SuccessModal
                open={successModalOpen}
                onClose={() => setSuccessModalOpen(false)}
                message='About gallery updated successfully'
            />
        </div>
    )
}

export default AboutGalleryModal
